export default __webpack_public_path__ + "static/media/010910_034.ad41a0af.jpg";